import * as T from '^/types';

export default {
  title: {
    [T.Language.KO_KR]: '담당자 목록',
    [T.Language.EN_US]: 'Assignees',
  },
};
